import { Link } from "react-router-dom";
import useUser from "../../../hooks/useUser";
import { getPermittedModules } from "./modules";

const ModuleCard = ({ module }) => {
  const ModuleIcon = module.icon;

  return (
    <Link
      className="group flex min-h-[160px] flex-col items-center justify-center rounded-lg border border-gray-200 bg-white p-6 text-center text-gray-600 shadow-sm transition hover:border-gray-300 hover:bg-gray-50 hover:text-gray-900 hover:shadow"
      to={module.pathname}
    >
      <div className="flex h-12 items-center justify-center">
        <ModuleIcon aria-hidden="true" className="max-h-10 max-w-10" />
      </div>
      <span className="mt-5 text-sm font-medium">{module.label}</span>
    </Link>
  );
};

const ModuleGrid = () => {
  const { hasPermission } = useUser();
  const permittedModules = getPermittedModules(hasPermission);

  return (
    <main className="mx-auto w-full max-w-6xl px-4 py-6 sm:px-6 sm:py-8 lg:px-8 lg:py-10">
      {permittedModules.length ? (
        <div className="grid grid-cols-2 gap-5 md:grid-cols-3 lg:grid-cols-4">
          {permittedModules.map(module => (
            <ModuleCard key={module.name} module={module} />
          ))}
        </div>
      ) : (
        <p className="text-sm text-gray-600">
          You do not have permission to access any modules.
        </p>
      )}
    </main>
  );
};

export default ModuleGrid;
